export const statsCardMessagesEn = {
  'statsCard.header': '{columnName} statistics',
  'statsCard.presentValues.label': 'Present values',
  'statsCard.missingValues.label': 'Missing values',
  'statsCard.uniqueValues.label': 'Unique values',
  'statsCard.earliestValue.label': 'Earliest value',
  'statsCard.latestValue.label': 'Latest value',
  'statsCard.minValue.label': 'Min value',
  'statsCard.maxValue.label': 'Max value',
  'statsCard.booleanValues.label': 'Boolean values',
  'statsCard.trueValues.label': 'True',
  'statsCard.falseValues.label': 'False',
  'statsCard.topValues.label': 'Top values',
  'statsCard.topValues.more': '+{remainingCount} more',
  'statsCard.topValues.less': 'Show less',
  'statsCard.error.title': 'Error',
  'statsCard.error.message': 'Unable to load column statistics. Try reloading the page.',
  'statsCard.loading': 'Loading statistics',
  'statsCard.noStatistics': 'No statistics available',
};
